"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doneAt = exports.isRunning = exports.isDone = exports.doneStatus = exports.isTimeLimit = undefined;

var _reselect = require("reselect");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _util = require("../../../util");

var Util = _interopRequireWildcard(_util);

var _combat = require("./combat");

var Main = _interopRequireWildcard(_combat);

var _teams = require("./teams");

var Teams = _interopRequireWildcard(_teams);

var _raw = require("./raw");

var Raw = _interopRequireWildcard(_raw);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTimeLimit = exports.isTimeLimit = (0, _reselect.createSelector)(Raw.get, function (s) {
  return s.event.type === "TIMELIMIT";
});
var doneStatus = exports.doneStatus = (0, _reselect.createSelector)(Teams.doneStatus, isTimeLimit, function (status, timelimit) {
  return status || (timelimit ? "draw" : null);
});
var isDone = exports.isDone = (0, _reselect.createSelector)(doneStatus, function (s) {
  return s != null;
});
var isRunning = exports.isRunning = _lodash2.default.negate(isDone);
var doneAt = exports.doneAt = (0, _reselect.createSelector)(isDone, Main.updatedAt, function (isDone, updatedAt) {
  return isDone ? updatedAt : null;
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ../core/lib/selectors/firebase/characters2/combat/done.js
// module id = 377
// module chunks = 0